const variables = {
  textHint: 'a4afb7',
  textPrimary: '#3c3c41',
  textSecondary: '#5b5b63',
  textTable: '#252244',

  breakpointXs: 0,
  breakpointSm: 600,
  breakpointMd: 960,
  breakpointLg: 1280,
  breakpointXl: 1560,
  marginChip: '6px 6px 6px 0.2rem',

  sansSerif: '"Roboto", "Helvetica", "Arial", sans-serif',

  backgroundPrimary: '#fdfbfa',
  backgroundSecondary: '#faf8f6',
  backgroundTertiary: '#b1b3b61f',
  backgroundFour: '#FFF6E8',

  error: '#fb1f1d',
  success: '#23be5f',

  grey1: '#fdfbfa',
  grey2: '#fdfdfd',
  grey3: '#ddd6d2',
  grey4: '#b1b3b6',
  grey5: '#f7f7f7',
  grey6: '#e5e5e5',

  primary1: '#ff6800',
  primary2: '#566789',
  primary3: '#4b7c62',
  primary4: '#5b5b63',
  primary5: '#E47A3E',
  primary6: '#FF9D00',
  ruleColor: '#ddd6d2',

  tertiary1: '#f4a111',
  tertiary2: '#fc3b1e',
  tertiary3: '#c69b2d',
  tertiary4: '#7b9a60',
  tertiary5: '#F5C884',
  tertiary6: '#2f66d3',
  tertiary7: '#966e42',
  tertiary8: '#EC9C23',

  headerHeight: '6.25rem',
  headerHeightMobile: '3.375rem',
};

export default variables;
